<template>
  <div class="product-container">
    <nav class="nav-header">
      <p @click="$router.push({name: 'system-admin-billing-invoices'})"
         :class="($route.name === 'system-admin-billing-invoices' || $route.name === 'system-admin-invoice-add') ? 'active' : ''">Invoices</p>
      <p @click="$router.push({name: 'system-admin-billing-payment'})"
         :class="($route.name === 'system-admin-billing-payment' || $route.name === 'system-admin-billing-add-payment') ? 'active' : ''">Payment</p>
    </nav>
    <router-view
    ass="router-container" />

  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.product-container {
    padding: 0 20px;
}
.product-container .nav-header {
    margin: 0 -20px;
}
.product-container {
  .nav-header {
    height: 50px;
    background-color: #fff;
    padding: 0px 10px 0px 10px;
    display: flex;
    p {
      cursor: pointer;
      height: calc(100% - 2px);
      display: flex;
      align-items: center;
      padding: 0px 5px 0px 5px;
      margin-right: 10px;
      color: #bdbfd8;
      font-family: ""Helvetica Neue"";
      font-size: 16px;
      font-weight: 500;
      line-height: 20px;
      text-align: center;
    }
    .active {
      color: #51a3f3;
      border-bottom: 2px solid #51a3f3;
    }
  }
  .router-container {
  }
}
</style>

